// Em dev local o socket sai pela origem da página e o proxy do Vite (`/socket`, ws: true) o leva ao
// mesmo backend da API. Localhost nunca pode cair num ambiente remoto.
const ehHostLocal = (hostname: string): boolean =>
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname === '[::1]' ||
  hostname.endsWith('.localhost')

type Pagina = Pick<Location, 'protocol' | 'hostname' | 'host'>

export const getWebSocketUrl = (endpoint: string, pagina: Pagina = window.location): string => {
  const apiUrl = process.env.REACT_APP_API_URL

  if (!apiUrl) {
    const isSecure = pagina.protocol === 'https:'
    const protocol = isSecure ? 'wss:' : 'ws:'
    const hostname = pagina.hostname

    if (ehHostLocal(hostname)) {
      return `${protocol}//${pagina.host}${endpoint}`
    }

    const base = hostname.includes('homolog') ? 'api-homologacao.lauduz.com' : 'api.lauduz.com'
    return `${protocol}//${base}${endpoint}`
  }

  const isWsSecure = apiUrl.startsWith('https')
  const wsProtocol = isWsSecure ? 'wss:' : 'ws:'
  const host = apiUrl.replace(/^https?:\/\//, '')

  return `${wsProtocol}//${host}${endpoint}`
}
